module.exports = __webpack_public_path__ + "infographic_design_cover_design_template_facebookdesign_digitalfactory_microfence.jpg?af6295f2aac37701fad23828b9f4ef86";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/infographic_design_cover_design_template_facebookdesign_digitalfactory_microfence.jpg
// module id = 54
// module chunks = 0